/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import Slider from "react-slick";
import { Spin, Carousel, Card, Col, Row } from 'antd';
import networkList from "../../constants/networkList";
import postService from "./../../services/httpService";
import moment from "moment";
import { data, event, isArray } from "jquery";
import { includes, none, update } from "ramda";
import logoImage from "../../assets/images/kims-logo.png";
import Marquee from "react-fast-marquee";
import BedTransferAccept from '../../assets/images/icons/bed-moving-Icon-1.svg';
//import BedTransferPending from '../../assets/images/icons/bed-moving-Icon-2.svg';
import BedTransferPending from '../../assets/images/icons/bed-moving-Icon-p-2.svg';
import BedTransfers from '../../assets/images/icons/bed-moving-Icon-3.svg';
import { wrap } from "lodash";

const $ = require("jquery");
const {homepage} = networkList;
var CurrentDate = moment().format('YYYY-MM-DD');
const display_count = 8;

class New_Nurse_display extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      blinkArray: [],
      renderType: "",
      meta: {},
      // h: window.innerHeight - 149,
      h: window.innerHeight - 149,

      previousData: [],
      vacant: [],
      houseKeeping: [],
      currentSlide: 0,
      currentPage: 1,
      total_page: 0,
      total_slides: null,
      display_data: null,
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const unit_id = params.get("unit_id");
    const ns_id = params.get("ns_id");

    if (unit_id && unit_id !== "null" && ns_id && ns_id !== "null") {
      this.setState({ loadding: true })
      this.renderBodydata(unit_id, ns_id, "init");
    }
    // this.speechText('init');
    document.getElementById("hidding_scroll").style.overflow = "hidden";
    var container = document.getElementById("tv-screen_body");
    // container.style.zoom="80%";
    document.body.style.zoom = "79%";
    // let width =window.screen.width;
    // if(width<=1536){
    //   document.body.style.zoom = "100%"; 
    // }else{
    //   document.body.style.zoom = "50%";
    // }
    //let width = window.innerWidth;
    // let height = window.innerHeight;
    // let isTV = (width > 1280 && height > 720);

    // if (isTV) {
    //   document.body.style.zoom = "70%";
    // } else {
    //   document.body.style.zoom = "100%";
    // }
    $(".custom-container").css({
      padding: "0px",
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // // checking the blinkArray is update
    // if (this.state.renderType === "second") {
    //   if (prevState.blinkArray.length > 0 && this.state.blinkArray.length > 0) {
    //     this.speechText("didupdate");
    //   } else {
    //     // console.log("enter to didupdate else No blinkarray");
    //   }
    // } else {
    //   // console.log("renderType:", this.state.renderType);
    // }

    // if(prevState.currentSlide !== this.state.currentSlide) {
    //   this.speechText("didupdate");
    // }
  }

  componentWillUnmount() {
    $("footer").css({ position: "relative", top: "unset" });
    // console.log("....unmount");
    this.state = {
      tableData: [],
    };
    document.getElementById("hidding_scroll").style.overflow = "auto";
  }

  renderBodydata(unit_id, ns_id, type) {
    let { blinkArray, tableData } = this.state;
    // localStorage.getItem("user_data");
    try {
      // let user_data = null;
      // if (localStorage.getItem("user_data")) {
      //   user_data = JSON.parse(localStorage.getItem("user_data"));
      // }
      this.setState({ previousData: tableData });
      let { getNurseStationDashboardInfoFromRedis } = networkList;
      postService(getNurseStationDashboardInfoFromRedis, "POST", {
        data: { ns_code: ns_id, unit_id: unit_id },
      }).then((res) => {
        if (res.status) {
          if (res.meta) {
            this.setState({ meta: res["meta"] });
          } else {
            this.setState({ meta: {} });
          }
          if (Array.isArray(res["data"]) && res["data"].length !== 0) {
            let { tableData } = this.state;
            let exists_counselled = tableData && tableData.length && tableData.map(function (el) {
              return el.id;
            });

            // res['data'].sort(function(a, b){return parseInt(a['counselled_by'])- parseInt(b['counselled_by'])})
            // res['data'].sort(function (a, b) {
            //     if (a.counsellor_name < b.counsellor_name) { return -1; }
            //     if (a.counsellor_name > b.counsellor_name) { return 1; }
            //     return 0;
            // })
            res["data"].map((data, key) => {
              if (exists_counselled && !exists_counselled.includes(data["id"])) {
                // res["data"][key]["blink_sound"] = "show_blink";
                // blinkArray.push(res["data"][key]);
              } else {
                // console.log("all !exists else");
              }
              // if(data["doctor_name"]!==''&& data["doctor_name"]!==null && data["doctor_name"]!==undefined){
              //   var reWhiteSpace = new RegExp("\\s+");
              //   if (reWhiteSpace.test(data["doctor_name"])) {

              // }else{
              //   if(data["doctor_name"].length>10){
              //     let joy=data["doctor_name"].match(/.{1,9}/g);
              //     data["doctor_name"]=joy.join(' ')
              //   }

              // }
              // }
              if (data["patient_name"] !== '' && data["patient_name"] !== null && data["patient_name"] !== undefined) {
                //   // console.log('manikanta');
                //     let replacedStr = "";
                //     let words = data["patient_name"].split(" ");
                //       for (let i = 0; i < words.length; i++) {
                //         let word = words[i];
                //         if(word.length>2){
                //           let firstLetter = word.charAt(0);
                //         let lastLetter = word.charAt(word.length - 1);
                //         let middleLetters = word.substring(1, word.length - 1).replace(/[a-zA-Z.]/g, "*");
                //         let replacedWord = firstLetter + middleLetters + lastLetter;
                //         replacedStr += replacedWord + " ";
                //         }else{
                //           let replacedWord = word.replace(/[a-zA-Z.]/g, "*");
                //           replacedStr += replacedWord + " ";
                //         }

                //       }
                //       data["patient_name"]=replacedStr;
                const arr = data["patient_name"].split(/(\.|\s+)/);
                // const arr = data["doctor_name"].split(" ");
                let patient_name = '';
                for (var i = 0; i < arr.length; i++) {
                  patient_name += ' ' + arr[i].charAt(0) + arr[i].slice(1).toLowerCase();
                }
                data["patient_name"] = patient_name;

              }
              if (data["doctor_name"] !== '' && data["doctor_name"] !== null && data["doctor_name"] !== undefined) {
                const arr = data["doctor_name"].split(/(\.|\s+)/);
                // const arr = data["doctor_name"].split(" ");
                let doctor_name = '';
                for (var i = 0; i < arr.length; i++) {
                  doctor_name += ' ' + arr[i].charAt(0) + arr[i].slice(1).toLowerCase();
                }
                data["doctor_name"] = doctor_name;
              }
              if (data["TRANSFER_CHECKIN_TIME"] || data.TRANSFER_STATUS === "T") {
                let checkin_time = moment(data["TRANSFER_CHECKIN_TIME"])
                let diff = moment().diff(checkin_time, "minutes")
                if (diff < 30) {
                  res["data"][key]["show_checkedin"] = true;
                } else {
                  res["data"][key]["show_checkedin"] = false;
                }
                // console.log("TRANSFER_CHECKIN_TIME checkin_time", checkin_time);
                // console.log("TRANSFER_CHECKIN_TIME current_time", moment());
                // console.log("TRANSFER_CHECKIN_TIME diff", diff);
              }
              tableData && tableData.length && tableData.map((tdata, tkey) => {
                // if (data['id'] !== tdata['id']) {
                //     // show blink for new tokens
                //     res['data'][key]['blink_sound'] = 'show_blink';
                //     blinkArray.push(res['data'][key])
                // } else

                // blink with TRANSFER_CHECKIN_STATUS
                if (data["TRANSFER_CHECKIN_STATUS"]) {
                  let checkin_time = moment(data["TRANSFER_CHECKIN_TIME"])
                  let diff = moment().diff(checkin_time, "minutes")
                  if (diff < 30) {
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  }
                } else
                  if (
                    data["id"] === tdata["id"] &&
                    data["bed_no"] !== tdata["bed_no"]
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  } else if (
                    data["id"] === tdata["id"] &&
                    data["doctor_name"] !== tdata["doctor_name"]
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  } else if (
                    data["id"] === tdata["id"] &&
                    data["los"] !== tdata["los"]
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  } else if (
                    data["id"] === tdata["id"] &&
                    data["patient_type"] !== tdata["patient_type"]
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  } else if (
                    data["id"] === tdata["id"] &&
                    data["surgeries"] && tdata["surgeries"] && data["surgeries"].length !== tdata["surgeries"].length
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  } else if (
                    data["id"] === tdata["id"] &&
                    data["appointments"] && tdata["appointments"] && data["appointments"].length !== tdata["appointments"].length
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  } else if (
                    data["id"] === tdata["id"] &&
                    data["pending_consents"] && tdata["pending_consents"] && data["pending_consents"].length !==
                    tdata["pending_consents"].length
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  } else if (
                    data["id"] === tdata["id"] &&
                    data["RemedinetInsuranceStatus"] && tdata["RemedinetInsuranceStatus"] && data["RemedinetInsuranceStatus"].length !==
                    tdata["RemedinetInsuranceStatus"].length
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  }
                  else if (
                    data["id"] === tdata["id"] &&
                    (data["discharge_process"] && tdata["discharge_process"] && data["discharge_process"].length !==
                      tdata["discharge_process"].length || data.discharge_req_dt !== tdata.discharge_req_dt || data.system_checkout !== tdata.system_checkout || data.physical_checkout !== tdata.physical_checkout)
                  ) {
                    // show blink for recall tokens
                    res["data"][key]["blink_sound"] = "show_blink";
                    blinkArray.push(res["data"][key]);
                  }

                  else {
                    // console.log("else");
                  }
              });
            });

            // console.log("blinkArray", blinkArray);
            // console.log(res["data"], tableData);
            let patientNameRemove = res["data"].filter(element => element.patient_name !== null);
            // console.log("patientNameRemove", patientNameRemove);

            patientNameRemove = patientNameRemove && patientNameRemove.length && patientNameRemove.filter(element => {
              if (!element.id && element["TRANSFER_CHECKIN_TIME"] && element.TRANSFER_STATUS === "T") {
                let checkin_time = moment(element["TRANSFER_CHECKIN_TIME"])
                let diff = moment().diff(checkin_time, "minutes")
                if (diff < 30) {
                  return element
                }
              }
              if (element.id) {
                return element
              }
            });
            // const occupancys=res["data"].filter(item=>(item.bed_status_cd)!=='V');
            // const vacant=res["data"].filter(item=>(item.bed_status_cd)==="V");
            let occupancys = patientNameRemove.filter(item => item.bed_status_cd === 'F' || item.TRANSFER_STATUS === "T");
            blinkArray = blinkArray && blinkArray.length > 0 && blinkArray.filter(element => element.patient_name !== null);
            blinkArray = blinkArray && blinkArray.length > 0 && blinkArray.filter(item => (item.bed_status_cd) !== 'V');

            const vacant = res["data"].filter(item => (item.bed_status_cd) === "V" || (item.bed_status_cd) === "R");
            const houseKeeping = res["data"].filter(item => (item.bed_status_cd) === "H");
            const attendent = res["data"].filter(item => item.bed_status_cd === "A");
            console.log('vacant', vacant);
            console.log('occupancys', occupancys);

            occupancys = occupancys.length > 0 && occupancys.sort((a, b) => (b.doctor_name && a.doctor_name) && b.doctor_name.localeCompare(a.doctor_name));
            let total_slides = occupancys.length ? Math.ceil(occupancys.length / display_count) : 1

            let display_data = [], rdata = []
            let slideBaseData = occupancys.length ? [...occupancys] : []
            for (let index = 0; index < total_slides; index++) {
              rdata = slideBaseData.splice(0, display_count);
              display_data.push({ slide: display_data.length + 1, data: rdata })
            }

            this.setState(
              (state) => ({
                tableData: occupancys,
                vacant: vacant,
                houseKeeping: houseKeeping,
                attendent: attendent,
                blinkArray: blinkArray ? blinkArray : [],
                renderType: type,
                loadding: false,
                total_page: total_slides,
                total_slides: total_slides,
                display_data: display_data,
              })
            );
          } else {
            this.setState((state) => ({
              tableData: [],
              vacant: [],
              houseKeeping: [],
              attendent: [],
              loadding: false
            }));
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  // sleep function
  sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  // call sleep by async
  delayed = async (ms) => {
    await this.sleep(ms);
  };
  // deleting the 1st object in blink array
  deleting = async (blinkArray, curentId) => {
    return new Promise((resolve, reject) => {

      if (blinkArray && Array.isArray(blinkArray) && blinkArray.length != 0) {
        const filterblinkArray = blinkArray.filter(item => {
          return item.id !== curentId;
        })
        // blinkArray.splice(0, 1);
        resolve(filterblinkArray);
        this.setState({ blinkArray: filterblinkArray })
      } else {
        // console.log("no deleting obj");
        resolve("");
      }
    });
  };
  // call the speechtext each object sync,3times with delay
  speechText = async (type, currentIndex) => {
    let { blinkArray, currentSlide, display_data, } = this.state;
    // console.log(type,'blinkArray',blinkArray)
    // previous code
    // if (blinkArray && Array.isArray(blinkArray) && blinkArray.length != 0 && tableData) {
    //   let i = blinkArray.length;
    //   let data;
    //   if(currentIndex&&currentIndex>0){
    //      data= tableData[currentIndex];
    //   }else{
    //     if(currentIndex==0){
    //       // data= tableData[tableData.length-1];
    //       data= tableData[currentIndex];
    //     }
    //   }
    //   if(currentIndex!==undefined){
    //     let currentBlink=blinkArray &&blinkArray.length>0 && blinkArray.filter((item)=>item.id==data.id && item.blink_sound==='show_blink')
    //     if(currentBlink!==undefined){
    //       let key = i;
    //       // var audio = new Audio('/assets/announcement.mp3');
    //       // audio.play();
    //       // call 3times
    //       // await this.callToken(blinkArray[0], key);
    //       // await this.callToken(blinkArray[0], key);
    //       // await this.callToken(blinkArray[0], key);
    //       await this.callToken(currentBlink[0], key);
    //       await this.callToken(currentBlink[0], key);
    //       await this.callToken(currentBlink[0], key);

    //       // delete 1st object
    //       // blinkArray = await this.deleting(blinkArray);
    //       blinkArray = await this.deleting(blinkArray,data.id);
    //     }
    //   }
    //   // let blinkLength = blinkArray.length;
    //   // for (const data of blinkArray) {
    //     // for (var j=0;blinkArray.length>0;){
    //     // delay 5s
    //     // await this.delayed(40000);
    //     // await this.delayed(3000);
    //   // }
    // } 

    if (blinkArray && Array.isArray(blinkArray) && blinkArray.length != 0 && display_data) {
      let i = blinkArray.length;
      let data;
      if (currentSlide > 0) {
        data = display_data[currentSlide]["data"];
      } else {
        if (currentSlide === 0) {
          data = display_data[currentSlide]["data"];
        }
      }
      if (currentSlide !== undefined) {
        let currentBlink = []
        if (blinkArray && data && blinkArray.length > 0 && blinkArray.length > 0) {
          let filtered_blinkArray = [...new Map(blinkArray.map(x => [x["id"], x])).values()]
          if (filtered_blinkArray) {
            data.map(dt => {
              filtered_blinkArray.map(ele => {
                if (ele.id === dt.id) {
                  currentBlink.push(ele)
                }
              })
            })
          }
        }
        if (currentBlink !== undefined) {
          let key = i;
          currentBlink.map(async ele => await this.callToken(ele, key))
        }
      }
    }
  };

  callToken = async (data, key) => {
    // console.log('callToken enter',data ,key)
    setTimeout(async () => {
      try {
        const collection = document.getElementsByClassName(`a${data.id}`);
        let len = collection.length ? collection.length : 0;
        for (let i = 0; i < len; i++) {
          collection[i].classList.add("blink_me");
        }
        await this.delayed(4000);
        for (let i = 0; i < len; i++) {
          collection[i].classList.remove("blink_me");
          // Add a comment to this line
        }
        // var synthesis = window.speechSynthesis;
        // if ('speechSynthesis' in window) {
        // var synthesis = window.speechSynthesis;
        // var voice = []

        // voice = window.speechSynthesis.getVoices().filter(function (voice) {
        //     return voice.lang === 'en-US';
        // });

        // var utterance = new SpeechSynthesisUtterance(`Token Number ${data ? data.token_display_id : null}`);

        // Set utterance properties
        // utterance.voice = voice[2];
        // utterance.pitch = 1;
        // utterance.rate = 1;
        // utterance.volume = 1;
        // adding blink css
        // var element = document.getElementById('a' + data.id);
        // element.classList.add("blink_me");
        // var element2 = document.getElementById('b' + data.id);
        // element2.classList.add("blink_me");
        // var element3 = document.getElementById("c" + data.id);
        // element3.classList.add("blink_me");
        // var element4 = document.getElementById("d" + data.id);
        // element4.classList.add("blink_me");
        // var element5 = document.getElementById("e" + data.id);
        // element5.classList.add("blink_me");
        // var element6 = document.getElementById("f" + data.id);
        // element6.classList.add("blink_me");
        // var element7 = document.getElementById("g" + data.id);
        // element7.classList.add("bg-success");
        // var element8 = document.getElementById("h" + data.id);
        // element8.classList.add("blink_me");
        // var element9 = document.getElementById("i" + data.id);
        // element9.classList.add("blink_me");
        // var element10 = document.getElementById("j" + data.id);
        // element10.classList.add("blink_me");
        // var element11 = document.getElementById("k" + data.id);
        // element11.classList.add("blink_me");
        // var element12 = document.getElementById("l" + data.id);
        // element12.classList.add("blink_me");
        // speech
        // synthesis.speak(utterance);
        // add delay 6s
        // await this.delayed(3000);
        // // remove blink css
        // var element = document.getElementById('a' + data.id);
        // element.classList.remove("blink_me");
        // var element2 = document.getElementById('b' + data.id);
        // element2.classList.remove("blink_me");
        // var element3 = document.getElementById('c' + data.id);
        // element3.classList.remove("blink_me");
        // var element4 = document.getElementById('d' + data.id);
        // element4.classList.remove("blink_me");
        // var element5 = document.getElementById('e' + data.id);
        // element5.classList.remove("blink_me");
        // var element6 = document.getElementById('f' + data.id);
        // element6.classList.remove("blink_me");
        // var element7 = document.getElementById('g' + data.id);
        // element7.classList.remove("bg-success");
        // var element8 = document.getElementById('h' + data.id);
        // element8.classList.remove("blink_me");
        // var element9 = document.getElementById('i' + data.id);
        // element9.classList.remove("blink_me");
        // var element10 = document.getElementById('j' + data.id);
        // element10.classList.remove("blink_me");
        // var element11 = document.getElementById('k' + data.id);
        // element11.classList.remove("blink_me");
        // var element12 = document.getElementById('l' + data.id);
        // element12.classList.remove("blink_me");
        // } else {
        //     console.log('Text-to-speech not supported.');
        // }
      } catch (error) {
        console.log(error);
      }
      return Promise.resolve(true);
    }, 10);
  };
  ageManipulation = (data) => {
    let agee = data && data["patient_age"] ? data["patient_age"] : null;
    if (agee) {
      let year = agee.substr(0, agee.indexOf("Y"));
      let month = agee.substr(0, agee.indexOf("M"));
      let day = agee.substr(0, agee.indexOf("D"));
      if (year !== null && year !== undefined && year !== "") {
        // console.log('age1:', agee.substr(0, agee.indexOf('Y')) + 'Y')
        return (
          agee.substr(0, agee.indexOf("Y")) + "Y"
          // "Y | " +
          // data["patient_gender"].substr(0, 1)
        );
      } else if (month !== null && month !== undefined && month !== "") {
        // console.log('age2:', agee.substr(0, agee.indexOf('M')) + 'M')
        return (
          agee.substr(0, agee.indexOf("M")) + "M"
          // "M | " +
          // data["patient_gender"].substr(0, 1)
        );
      } else if (day !== null && day !== undefined && day !== "") {
        // console.log('age3:', agee.substr(0, agee.indexOf('D')) + 'D')
        return (
          agee.substr(0, agee.indexOf("D")) + "D"
          // "D | " +
          // data["patient_gender"].substr(0, 1)
        );
      } else {
        return " ";
      }
    } else {
      return " ";
    }
  };
  pending_consents_status_color = (data, previousData) => {
    try {
      if (data) {
        if (previousData.length > 0) {
          if (previousData.some((item) => item.ip_no === data.ip_no)) {
            const index = previousData
              .map((item) => item.ip_no)
              .indexOf(data.ip_no);
            if (previousData[index].pending_consents.length > 0) {
              if (
                previousData[index].pending_consents[0].consent_name !==
                data.pending_consents[0].consent_name
              ) {
                return "bg-success text-white text-center";
              } else {
                return "text-white text-centert";
              }
            } else {
              return "text-white text-center";
            }
          } else {
            return "text-white text-center";
          }
        } else {
          return "text-white text-center";
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  surgeries_status_color = (data) => {
    return "bg-success text-white p-2 border-bottom text-left h-100";
    // if (data) {
    //     if (data.approval_status === 'rejected') {
    //         return 'bg-danger text-white p-2 border-bottom text-left'
    //     } else if (data.approval_status === 'approved') {
    //         return 'bg-success text-white p-2 border-bottom text-left'
    //     } else {
    //         return 'bg-white text-gray p-2 border-bottom text-left'
    //     }
    // } else {
    //     return null
    // }
  };
  surgeriesBgSucces = (data, previousData) => {
    try {
      if (data && data.surgeries && data.surgeries.length > 0) {
        if (previousData.length > 0) {
          if (previousData.some((item) => item.ip_no === data.ip_no)) {
            const index = previousData
              .map((item) => item.ip_no)
              .indexOf(data.ip_no);
            if (previousData[index].surgeries.length > 0) {
              let previousSurgriesdata = previousData[index].surgeries;
              previousSurgriesdata.map((item, key) => {
                previousSurgriesdata[key]["dateTime"] =
                  item.appointment_date + " " + item.start_time;
              });

              previousSurgriesdata.sort(function (a, b) {
                return new Date(b.dateTime) - new Date(a.dateTime);
              });

              let surgeriesdata = data.surgeries;
              surgeriesdata.map((item, key) => {
                surgeriesdata[key]["dateTime"] =
                  item.appointment_date + " " + item.start_time;
              });
              surgeriesdata.sort(function (a, b) {
                return new Date(b.dateTime) - new Date(a.dateTime);
              });
              if (
                previousSurgriesdata[0].start_time === surgeriesdata[0].start_time
              ) {
                return (
                  <div className="text-white  text-center ">
                    {/* <div>
                  {surgeriesdata[0].procedure_name &&surgeriesdata[0].procedure_name.length>30
                    ? surgeriesdata[0].procedure_name.substring(0, 30) + "..."
                    :surgeriesdata[0].procedure_name}
                  </div> */}
                    <div>
                      {surgeriesdata[0].appointment_date
                        ? moment(surgeriesdata[0].appointment_date).format(
                          "DD/MM/YY")
                        : " "}
                    </div>
                    <div >
                      {/* {surgeriesdata[0].start_time
                      ? ' @ '+moment(surgeriesdata[0].start_time, "hh:mm A").format(
                        "hh:mm A"
                      )
                      : " "} */}
                      {surgeriesdata[0].start_time
                        ? '@ ' + moment(surgeriesdata[0].start_time, "hh:mm A").format(
                          "hh:mm A"
                        )
                        : " "}
                    </div>
                  </div>
                );
              } else {
                let surgeriesdata = data.surgeries;
                surgeriesdata.map((item, key) => {
                  surgeriesdata[key]["dateTime"] =
                    item.appointment_date + " " + item.start_time;
                });
                surgeriesdata.sort(function (a, b) {
                  return new Date(b.dateTime) - new Date(a.dateTime);
                });
                return (
                  <div className="bg-success text-white  text-center ">
                    {/* <div>
                  {surgeriesdata[0].procedure_name &&surgeriesdata[0].procedure_name.length>30
                    ? surgeriesdata[0].procedure_name.substring(0, 30) + "..."
                    :surgeriesdata[0].procedure_name}
                  </div> */}
                    <div>
                      {surgeriesdata[0].appointment_date
                        ? moment(surgeriesdata[0].appointment_date).format(
                          "DD/MM/YY")
                        : " "}
                    </div>
                    <div>
                      {surgeriesdata[0].start_time
                        ? '@ ' + moment(surgeriesdata[0].start_time, "hh:mm A").format(
                          "hh:mm A"
                        )
                        : " "}
                    </div>
                  </div>
                );
              }
            } else {
              let surgeriesdata = data.surgeries;
              surgeriesdata.map((item, key) => {
                surgeriesdata[key]["dateTime"] =
                  item.appointment_date + " " + item.start_time;
              });
              surgeriesdata.sort(function (a, b) {
                return new Date(b.dateTime) - new Date(a.dateTime);
              });
              return (
                <div className="bg-success text-white  text-center ">
                  {/* <div> */}
                  {/* {surgeriesdata[0].procedure_name &&surgeriesdata[0].procedure_name.length>30
                ? surgeriesdata[0].procedure_name.substring(0, 30) + "..."
                :surgeriesdata[0].procedure_name} */}
                  {/* </div> */}
                  <div>
                    {surgeriesdata[0].appointment_date
                      ? moment(surgeriesdata[0].appointment_date).format(
                        "DD/MM/YY")
                      : " "}
                  </div>
                  <div style={{ padding: '32px 0px' }}>
                    {surgeriesdata[0].start_time
                      ? '@ ' + moment(surgeriesdata[0].start_time, "hh:mm A").format(
                        "hh:mm A"
                      )
                      : " "}
                  </div>
                </div>
              );
            }
          } else {
            let surgeriesdata = data.surgeries;
            surgeriesdata.map((item, key) => {
              surgeriesdata[key]["dateTime"] =
                item.appointment_date + " " + item.start_time;
            });
            surgeriesdata.sort(function (a, b) {
              return new Date(b.dateTime) - new Date(a.dateTime);
            });
            return (
              <div className="bg-success text-white text-center ">
                {/* <div>
              {surgeriesdata[0].procedure_name &&surgeriesdata[0].procedure_name.length>30
                ? surgeriesdata[0].procedure_name.substring(0, 30) + "..."
                :surgeriesdata[0].procedure_name}
              </div> */}
                <div>
                  {surgeriesdata[0].appointment_date
                    ? moment(surgeriesdata[0].appointment_date).format(
                      "DD/MM/YY")
                    : " "}
                </div>
                <div style={{ padding: '32px 0px' }}>
                  {surgeriesdata[0].start_time
                    ? '@ ' + moment(surgeriesdata[0].start_time, "hh:mm A").format(
                      "hh:mm A"
                    )
                    : " "}
                </div>
              </div>
            );
          }
        } else {
          let surgeriesdata = data.surgeries;
          surgeriesdata.map((item, key) => {
            surgeriesdata[key]["dateTime"] =
              item.appointment_date + " " + item.start_time;
          });
          surgeriesdata.sort(function (a, b) {
            return new Date(b.dateTime) - new Date(a.dateTime);
          });
          return (
            <div className="bg-success text-white  text-center ">
              {/* <div>
              {surgeriesdata[0].procedure_name &&surgeriesdata[0].procedure_name.length>30
                ? surgeriesdata[0].procedure_name.substring(0, 30) + "..."
                :surgeriesdata[0].procedure_name}
            </div> */}
              <div>
                {surgeriesdata[0].appointment_date
                  ? moment(surgeriesdata[0].appointment_date).format(
                    "DD/MM/YY")
                  : " "}
              </div>
              <div>
                {surgeriesdata[0].start_time
                  ? '@ ' + moment(surgeriesdata[0].start_time, "hh:mm A").format(
                    "hh:mm A"
                  )
                  : " "}
              </div>
            </div>
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  appointmentsBgSucces = (data, previousData) => {
    try {
      if (data && data.appointments && data.appointments.length > 0) {
        if (previousData.length > 0) {
          if (previousData.some((item) => item.ip_no === data.ip_no)) {
            const index = previousData
              .map((item) => item.ip_no)
              .indexOf(data.ip_no);
            if (previousData[index].appointments.length > 0) {
              let previousappointments = previousData[index].appointments;
              previousappointments.map((item, key) => {
                previousappointments[key]["dateTime"] =
                  item.appointment_date + " " + item.start_time;
              });

              previousappointments.sort(function (a, b) {
                return new Date(b.dateTime) - new Date(a.dateTime);
              });

              let appointmentsdata = data.appointments;
              appointmentsdata.map((item, key) => {
                appointmentsdata[key]["dateTime"] =
                  item.appointment_date + " " + item.start_time;
              });
              appointmentsdata.sort(function (a, b) {
                return new Date(b.dateTime) - new Date(a.dateTime);
              });
              if (
                previousappointments[0].start_time ===
                appointmentsdata[0].start_time
              ) {
                return (
                  <div>
                    <div className=" text-white  text-center ">
                      <div>
                        {appointmentsdata && appointmentsdata.map((felid, index) => {
                          if (index == 0) {
                            if (felid.start_time) {
                              return (
                                felid.service_groupid + ' @ ' + felid.start_time

                              )
                            } else {
                              return (
                                felid.service_groupid

                              )
                            }

                          } else {
                            if (felid.start_time) {
                              return (
                                ' , ' + felid.service_groupid + ' @ ' + felid.start_time

                              )
                            } else {
                              return (
                                ' , ' + felid.service_groupid

                              )
                            }
                          }

                        })}
                      </div>

                    </div>
                  </div>

                );
              }
              else {
                let appointmentsdata = data.appointments;
                appointmentsdata.map((item, key) => {
                  appointmentsdata[key]["dateTime"] =
                    item.appointment_date + " " + item.start_time;
                });
                appointmentsdata.sort(function (a, b) {
                  return new Date(b.dateTime) - new Date(a.dateTime);
                });

                return (
                  <div>
                    <div className="bg-success text-white  text-center ">
                      <div>
                        {appointmentsdata && appointmentsdata.map((felid, index) => {
                          if (index == 0) {
                            if (felid.start_time) {
                              return (
                                felid.service_groupid + ' @ ' + felid.start_time

                              )
                            } else {
                              return (
                                felid.service_groupid

                              )
                            }

                          } else {
                            if (felid.start_time) {
                              return (
                                ' , ' + felid.service_groupid + ' @ ' + felid.start_time

                              )
                            } else {
                              return (
                                ' , ' + felid.service_groupid

                              )
                            }
                          }
                        })}
                      </div>
                    </div>
                  </div>

                );
              }
            } else {
              let appointmentsdata = data.appointments;
              appointmentsdata.map((item, key) => {
                appointmentsdata[key]["dateTime"] =
                  item.appointment_date + " " + item.start_time;
              });
              appointmentsdata.sort(function (a, b) {
                return new Date(b.dateTime) - new Date(a.dateTime);
              });
              return (
                <div>
                  <div className="bg-success text-white  text-center ">
                    <div>
                      {appointmentsdata && appointmentsdata.map((felid, index) => {
                        if (index == 0) {
                          if (felid.start_time) {
                            return (
                              felid.service_groupid + ' @ ' + felid.start_time

                            )
                          } else {
                            return (
                              felid.service_groupid

                            )
                          }

                        } else {
                          if (felid.start_time) {
                            return (
                              ' , ' + felid.service_groupid + ' @ ' + felid.start_time

                            )
                          } else {
                            return (
                              ' , ' + felid.service_groupid

                            )
                          }
                        }
                      })}
                    </div>
                  </div>
                </div>

              );
            }
          } else {
            let appointmentsdata = data.appointments;
            appointmentsdata.map((item, key) => {
              appointmentsdata[key]["dateTime"] =
                item.appointment_date + " " + item.start_time;
            });
            appointmentsdata.sort(function (a, b) {
              return new Date(b.dateTime) - new Date(a.dateTime);
            });
            return (
              <div>
                <div className="bg-success text-white  text-center ">
                  <div>
                    {appointmentsdata && appointmentsdata.map((felid, index) => {
                      if (index == 0) {
                        if (felid.start_time) {
                          return (
                            felid.service_groupid + ' @ ' + felid.start_time

                          )
                        } else {
                          return (
                            felid.service_groupid

                          )
                        }

                      } else {
                        if (felid.start_time) {
                          return (
                            ' , ' + felid.service_groupid + ' @ ' + felid.start_time

                          )
                        } else {
                          return (
                            ' , ' + felid.service_groupid

                          )
                        }
                      }
                    })}
                  </div>
                </div>
              </div>

            );
          }
        } else {
          let appointmentsdata = data.appointments;
          appointmentsdata.map((item, key) => {
            appointmentsdata[key]["dateTime"] =
              item.appointment_date + " " + item.start_time;
          });
          appointmentsdata.sort(function (a, b) {
            return new Date(b.dateTime) - new Date(a.dateTime);
          });
          // console.log('appointmentsdata',appointmentsdata)
          // return (
          //   <div className="bg-success text-white  text-center ">
          //     <div>
          //       {appointmentsdata[0].service_groupid
          //         ? appointmentsdata[0].service_groupid
          //         : " "}
          //     </div>
          //     <div>
          //       {appointmentsdata[0].start_time
          //         ? moment(appointmentsdata[0].start_time, "hh:mm A").format(
          //           "hh:mm A"
          //         )
          //         : "  "}
          //     </div>
          //   </div>
          // );

          return (
            <div>
              <div className="bg-success text-white  text-center ">
                <div>
                  {appointmentsdata && appointmentsdata.map((felid, index) => {
                    if (index == 0) {
                      if (felid.start_time) {
                        return (
                          felid.service_groupid + ' @ ' + felid.start_time

                        )
                      } else {
                        return (
                          felid.service_groupid

                        )
                      }

                    } else {
                      if (felid.start_time) {
                        return (
                          ' , ' + felid.service_groupid + ' @ ' + felid.start_time

                        )
                      } else {
                        return (
                          ' , ' + felid.service_groupid

                        )
                      }
                    }
                  })}
                </div>
              </div>
            </div>

          );

        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  handleAfterChange = (e) => {
    try {
      let { tableData } = this.state
      if (tableData.length > 0) {
        if (tableData.length === e + 1) {
          const params = new URLSearchParams(this.props.location.search);
          const unit_id = params.get("unit_id");
          const ns_id = params.get("ns_id");
          if (unit_id && unit_id !== "null" && ns_id && ns_id !== "null") {
            this.renderBodydata(unit_id, ns_id, "second");
          }
        }

      }
    } catch (error) {
      console.log(error);
    }
  };
  handleBeforeChange = (current, next) => {
    if (current !== undefined) {
      this.speechText('didupdate', current);
    }
    // console.log(current, next)
  }
  setCurrentSlide = (currentSlide) => {
    // console.log("currentSlide", currentSlide);
    const { tableData } = this.state;
    const params = new URLSearchParams(this.props.location.search);
    const unit_id = params.get("unit_id");
    const ns_id = params.get("ns_id");
    let total_slides = tableData.length ? Math.ceil(tableData.length / display_count) : 1
    if (currentSlide + 1 === total_slides) {
      this.renderBodydata(unit_id, ns_id, "second")
    }
    this.setState({ currentSlide: currentSlide, currentPage: currentSlide + 1, total_page: total_slides });
  };

  showTransferNS = (patientData) => {
    let data = patientData.bedTransferStatus.length && patientData.bedTransferStatus.sort((a, b) => (b.REQ_APPROVALDT && a.REQ_APPROVALDT) && (new Date(b.REQ_APPROVALDT) - new Date(a.REQ_APPROVALDT)))[0]
    if (patientData.TRANSFER_STATUS) {
      if (patientData.TRANSFER_CHECKIN_STATUS) {
        if (patientData["show_checkedin"]) {
          // console.log("showTransferNS patientData 1", patientData);
          // console.log("showTransferNS 1", data);
          // return <>{`${data.FROMNURSESTATIONNAME ? data.FROMNURSESTATIONNAME : ""} ${data.TONURSESTATIONNAME ? "->" : ""} ${data.TONURSESTATIONNAME ? data.TONURSESTATIONNAME : ""}`}</>
          return <>{`${data.FROMWARDNAME ? data.FROMWARDNAME : ""}/${data.FROMROOMCD ? data.FROMROOMCD : ""}/${data.FROMBEDCD ? data.FROMBEDCD: ""} ${data.TOWARDNAME ? "->" : ""} ${data.TOWARDNAME ? data.TOWARDNAME : ""}/${data.TOROOMCD ? data.TOROOMCD: ""}/${data.TOBEDCD ? data.TOBEDCD: ""}`}</>
        }
      } else {
        // console.log("showTransferNS patientData 2", patientData);
        // console.log("showTransferNS 2", data);
        //return <>{`${data.FROMNURSESTATIONNAME ? data.FROMNURSESTATIONNAME : ""} ${data.TONURSESTATIONNAME ? "->" : ""} ${data.TONURSESTATIONNAME ? data.TONURSESTATIONNAME : ""}`}</>
        return <>{`${data.FROMWARDNAME ? data.FROMWARDNAME : ""}/${data.FROMROOMCD ? data.FROMROOMCD : ""}/${data.FROMBEDCD ? data.FROMBEDCD: ""} ${data.TOWARDNAME ? "->" : ""} ${data.TOWARDNAME ? data.TOWARDNAME : ""}/${data.TOROOMCD ? data.TOROOMCD: ""}/${data.TOBEDCD ? data.TOBEDCD: ""}`}</>
      }
    }
  }

  displayCrossCons = (list) => {
    let array = list.split(",")
    if (array.length) {
      array = [...new Set(array)]
      return (
        // <div className="doctorFontSize">
        <>
          {array.map((ele, key) => {
            if (key < 2) {
              const arr1 = ele.split(".")
              for (var i = 0; i < arr1.length; i++) {
                arr1[i] = arr1[i].charAt(0).toUpperCase() + arr1[i].slice(1).toLowerCase();
              }
              const str1 = arr1.join(".");

              const arr2 = str1.split(" ")
              for (var i = 0; i < arr2.length; i++) {
                arr2[i] = arr2[i].charAt(0).toUpperCase() + arr2[i].slice(1);
              }
              let str2 = arr2.join(" ");

              if (str2.length > 12) {
                str2 = str2.substring(0, 20) + ".."
              }

              // return <p className={`${str2.length > 20 && "doctorFontSize"} px-1 mb-0`}>{"Dr. " + str2}</p>
              return <p className="px-1 mb-0">{"Dr. " + str2}</p>
            }
          })}
          {array.length > 2 && <p className="px-1 mb-0">....</p>}
          {/* </div> */}
        </>
      )
      // return array.map((ele, key) => <div>{ele}</div>)
    }
  }

  displayDiettypes = (list) => {
    let array = list.split(",")
    if (array.length) {
      array = [...new Set(array)]
      return (
        <>
          {array.map((ele, key) => {
            if (key < 2) {
              return <div>{ele}</div>
            }
          })}
          {array.length > 2 && <div>...</div>}
        </>
      )
    }
  }

  render() {
    let { tableData, meta, previousData, vacant, houseKeeping, attendent, total_slides, display_data, loadding, } = this.state;
    var setting = {
      speed: 10000,
      initialSlide: 1,
      autoplay: true,
      autoplaySpeed: 0,
      vertical: true,
      verticalSwiping: true,
      cssEase: "linear",
      slidesToShow: tableData.length >= 7 ? 8 : tableData.length,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      centerMode: true,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            initialSlide: 1,
            slidesToShow: tableData.length > 8 ? vacant.length > 0 ? 8 : 8 : tableData.length,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 1366,
          settings: {
            initialSlide: 1,
            slidesToShow: tableData.length > 5 ? vacant.length > 0 ? 6 : 6 : tableData.length,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            initialSlide: 1,
            slidesToShow: tableData.length > 10 ? vacant.length > 0 ? 10.8 : 10.8 : tableData.length,
            slidesToScroll: 1,
            infinite: true,
          }
        },
      ]
    }
    let url = window.location.href;
    url = url.split("=");
    const image = url[2];

    let footerArray = [];
    if (vacant && vacant.length) {
      footerArray.push(...vacant)
    }
    if (houseKeeping && houseKeeping.length) {
      footerArray.push(...houseKeeping)
    }
    if (attendent && attendent.length) {
      footerArray.push(...attendent)
    }

    //  let total_slides = tableData.length ? Math.ceil(tableData.length/display_count) : 1
    //  let display_data = [], rdata = []
    //  let slideBaseData =tableData.length && [...tableData]
    //  if(tableData.length>0){
    //   for (let index = 0; index < total_slides; index++) {
    //     rdata = slideBaseData.splice(0, display_count);
    //     display_data.push({slide: display_data.length+1, data: rdata})
    //   }
    //  }
    return (
      <div style={{ backgroundColor: "white" }}>
        <header id="navbar" style={{ backgroundColor: "white" }}>
          <div className="container-fluid d-print-none pl-3 pr-3" >
            <div className="row">
              <div className="col-2 my-auto">
                <div className="logo my-2">
                  <img
                    // src={logoImage}
                    src={`${homepage}/assets/images/units-logo/${image + '.png'}`}
                    alt="KIMS QMS Logo"
                    className="w-100 h-100"
                  />
                </div>
              </div>
              <div className="col-2 my-auto border-right" >
                <p className="tv-nav-data">
                  {meta.nurse_station || meta.nurse_station == 0
                    ? meta.nurse_station.substring(0, 18).toUpperCase() +
                    "..."
                    : "--"}
                </p>
                <p className="tv-nav-label">Nursing Station</p>
              </div>
              <div className="col-6 pl-1 my-auto d-inline-flex border-right">
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.occupancy || meta.occupancy == 0
                      ? meta.occupancy
                      : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>
                    Occupancy
                  </p>
                </div>

                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.general || meta.general == 0 ? meta.general : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>
                    General
                  </p>
                </div>
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.corporate || meta.corporate == 0
                      ? meta.corporate
                      : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>
                    Corporate
                  </p>
                </div>
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.insurance || meta.insurance == 0
                      ? meta.insurance
                      : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>
                    Insurance
                  </p>
                </div>
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.vacant || meta.vacant == 0 ? meta.vacant : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>
                    Vacant Beds
                  </p>
                </div>
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.HK_beds || meta.HK_beds == 0 ? meta.HK_beds : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>
                    House Keeping
                  </p>
                </div>
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.retain_beds || meta.retain_beds == 0 ? meta.retain_beds : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>
                    Retained
                  </p>
                </div>
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.attendent_beds || meta.attendent_beds == 0 ? meta.attendent_beds : "--"}
                  </p>
                  <p className="tv-nav-label-two" style={{ textAlign: "center" }}>Attendant Using</p>
                </div>
              </div>
              <div className="col-2 pl-1 my-auto d-inline-flex">
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.investigations || meta.investigations == 0
                      ? meta.investigations
                      : "--"}
                  </p>
                  <p className="tv-nav-label" style={{ textAlign: "center" }}>
                    Inv
                  </p>
                </div>
                <div className="w-50">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    --
                  </p>
                  <p className="tv-nav-label" style={{ textAlign: "center" }}>
                    Cross Con
                  </p>
                </div>
                <div className="w-25">
                  <p className="tv-nav-data" style={{ textAlign: "center" }}>
                    {meta.discharge_initiated || meta.discharge_initiated == 0
                      ? meta.discharge_initiated
                      : "--"}
                  </p>
                  <p className="tv-nav-label" style={{ textAlign: "center" }}>
                    Discharge
                  </p>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', backgroundColor: "white" }}>
          <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'row' }}>
            <div style={{ textAlign: 'center', marginRight: '30px', display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '12px', height: '12px', background: '#FF3AE5', marginTop: '5px', marginRight: '10px' }} /><p style={{ color: '#B2B2B2' }}>House Keeping</p>
            </div>
            <div style={{ textAlign: 'center', marginRight: '30px', display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '12px', height: '12px', background: '#E31A47', marginTop: '5px', marginRight: '10px' }} /><p style={{ color: '#B2B2B2' }}>Nursing</p>
            </div>
            <div style={{ textAlign: 'center', marginRight: '30px', display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '12px', height: '12px', background: '#FFB300', marginTop: '5px', marginRight: '10px' }} /><p style={{ color: '#B2B2B2' }}>F&B</p>
            </div>
            <div style={{ textAlign: 'center', marginRight: '30px', display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '12px', height: '12px', background: '#FFEE01', marginTop: '5px', marginRight: '10px' }} /><p style={{ color: '#B2B2B2' }}>Facilities</p>
            </div>
            <div style={{ textAlign: 'center', marginRight: '30px', display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '12px', height: '12px', background: '#9F00CE', marginTop: '5px', marginRight: '10px' }} /><p style={{ color: '#B2B2B2' }}>I Portor</p>
            </div>
          </div>
        </div>


        {display_data && display_data.length > 0 &&
          <Carousel
            autoplay
            pauseOnHover={false}
            afterChange={(currentSlide) => this.setCurrentSlide(currentSlide)}
            key={total_slides.toString()}
            autoplaySpeed={14000}
            dots={false}
          >
            {display_data.length > 0 && display_data.map((slideData, skey) => {
              return (
                <div id={slideData.slide}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', background: 'white' }}>
                    {slideData["data"].length > 0 && slideData["data"].map((record, key) => (
                      <div key={key} style={{ border: '1px solid #007DB0', background: 'white', borderRadius: '25px', textAlign: 'center', margin: '10px', flex: 1 }}>
                        <div style={{ display: 'flex', marginTop: '5px' }}>

                          <div style={{ display: 'flex', width: '35%' }}>
                            <div style={{ width: '40%', flex: 1, }}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {/* {record.patient_gender === "Female" ?
                                  <img src="/assets/images/icons/female.png" width={20} height={20} style={{ marginLeft: '20px', marginTop: '2px' }} /> :
                                  <img src="/assets/images/icons/male.png" width={20} height={20} style={{ marginLeft: '20px', marginTop: '2px' }} />
                                } */}
                                {record.patient_name && record.patient_name.length > 0 ?
                                    (
                                      record.patient_gender === "Female" ?
                                        <img src="/assets/images/icons/female.png" width={20} height={20} style={{ marginLeft: '20px', marginTop: '2px' }} /> :
                                        <img src="/assets/images/icons/male.png" width={20} height={20} style={{ marginLeft: '20px', marginTop: '2px' }} />
                                    )
                                    : null
                                }
                                <p style={{ fontSize: '16px', fontWeight: '500', margin: '0', color: 'black', marginLeft: '2px' }}>
                                  {(record.patient_name && record.patient_name.length) > 12
                                    ? record.patient_name.substring(0, 16) + ".."
                                    : record.patient_name ? record.patient_name : ""}
                                </p>
                                {/* <p style={{ fontSize: '16px', fontWeight: '500', margin: '0', color: 'black', marginLeft: '2px' }}>({this.ageManipulation(record)})</p> */}
                                <p style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                  margin: '0',
                                  color: 'black',
                                  marginLeft: '2px'
                                }}>
                                  {this.ageManipulation(record) !== " " ? `(${this.ageManipulation(record)})` : ''}
                                </p>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <p style={{ fontSize: '16px', fontWeight: '500', margin: '0', color: 'black', marginLeft: '42px' }}>{record.bed_no ? record.bed_no : ""}</p>
                                <p style={{ fontSize: '16px', fontWeight: '500', margin: '0', color: 'black', marginLeft: '5px', whiteSpace: 'nowrap' }}>
                                  {/* ({record.patient_type === "CORPORATE" ? record.patient_type.substring(0, 4) : record.patient_type.substring(0, 3)}{""}{`${'|'}`}{record.los ? record.los : record.los || record.los ? '--' : " "}{record.elos ? '/' + record.elos : record.los || record.los ? "/-" : ' '} Days) */}
                                  ({record.patient_type ? (record.patient_type === "CORPORATE" ? record.patient_type.substring(0, 4) : record.patient_type.substring(0, 3)) : ""}{""}{`${'|'}`}{record.los ? record.los : record.los || record.los ? '--' : " "}{record.elos ? '/' + record.elos : record.los || record.los ? "/-" : ' '} Days)
                                </p>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <p style={{ fontSize: '16px', fontWeight: '500', margin: '0px', color: 'black', marginLeft: '42px' }}>{record.ip_no ? record.ip_no : " "}</p>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                              {record.doctor_name ? <img src="/assets/images/icons/doctor.png" width={16} height={16} style={{ marginLeft: '20px', marginBottom: '5px' }} /> : null }
                                <p style={{ fontSize: record.doctor_name && record.doctor_name.length > 20 ? '14px' : '16px', fontWeight: '500', margin: '0px', color: 'black', marginLeft: '5px' }}>
                                  {record.doctor_name && record.doctor_name.length > 13
                                    ? "Dr." + record.doctor_name.substring(0, 20) + ".."
                                    : record.doctor_name ? "Dr." + record.doctor_name : " "}
                                </p>
                              </div>
                            </div>
                            <div style={{ width: '50px', height: '90px' }}>
                              {record.TRANSFER_STATUS &&
                                record.TRANSFER_CHECKIN_STATUS
                                ? record["show_checkedin"] && <img src={BedTransfers} alt="BedTransfers" width={25} height={25} />
                                : record.TRANSFER_STATUS === "N"
                                  ? <img src={BedTransferPending} alt="BedTransferPending" width={25} height={25} />
                                  : record.TRANSFER_STATUS === "T" && <img src={BedTransferAccept} alt="BedTransferAccept" width={25} height={25} />
                              }
                              {record.RemedinetInsuranceStatus && record.RemedinetInsuranceStatus.length > 0 && record.RemedinetInsuranceStatus[0].payer_status ?
                                <img src="/assets/images/icons/insurance-logo.png" width={24} height={24} style={{ marginRight: '40px', marginTop: '10px' }} />
                                : <span> </span>}
                            </div>
                          </div>
                          <div style={{ borderLeft: '1px solid #707070', margin: '5px', marginBottom: '12px' }} />
                          <div style={{ display: 'flex', width: '26%' }}>
                            <div style={{ width: '300px', flex: 1 }}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {(record.discharge_process && record.discharge_process.length && record.discharge_process[0].ds_approved_date) || record.discharge_req_dt || record.physical_checkout || record.system_checkout ?
                                  <img src="/assets/images/icons/bed.png" width={24} height={24} style={{ marginLeft: '18px', marginTop: '10px' }} />
                                  : null}
                                <div style={{ flexDirection: 'column',marginLeft: '8%'}}>
                                  <p style={{ fontSize: '14px', fontWeight: '600', margin: '0px', color: '#E31A47', marginLeft: '5px' }}>
                                    {record.discharge_req_dt
                                      ? 'DI @ ' + moment(record.discharge_req_dt).format("hh:mm A")
                                      : " "}
                                  </p>
                                  <p style={{ fontSize: '14px', fontWeight: '600', margin: '0px', color: '#E31A47', marginLeft: '5px' }}>
                                    {record.discharge_process && record.discharge_process.length && record.discharge_process[0].ds_approved_date
                                      ? 'DS @ ' + moment(record.discharge_process[0].ds_approved_date).format("hh:mm A")
                                      : " "}
                                  </p>
                                  <p style={{ fontSize: '14px', fontWeight: '600', margin: '0px', color: '#E31A47', marginLeft: '5px' }}>
                                    {record.system_checkout ? `${'SC @ '}` : ''}
                                    {record.system_checkout
                                      ? moment(record.system_checkout).format(
                                        "hh:mm A"
                                      )
                                      : " "}
                                  </p>
                                  <p style={{ fontSize: '14px', fontWeight: '600', margin: '0px', color: '#E31A47', marginLeft: '5px' }}>
                                    {record.physical_checkout ? `${'PC @ '}` : ''}
                                    {record.physical_checkout
                                      ? moment(record.physical_checkout).format(
                                        "hh:mm A"
                                      )
                                      : " "}
                                  </p>
                                </div>
                              </div>
                              <div style={{ display: 'flex' }}>
                                {record && record.patient_diettypes ?
                                  <i class="fas fa-utensils text-success" style={{ marginLeft: '20px', marginBottom: '5px' }} /> : null}
                                <p style={{ fontSize: '15px', fontWeight: '500', color: '#E31A47', flex: 1 }}>
                                  {record && record.patient_diettypes ? record.patient_diettypes : ""}
                                </p>
                              </div>

                              <div style={{ display: 'flex' }}>
                                {record && record.cross_consultation ? <img src="/assets/images/icons/doctor.png" width={16} height={16} style={{ marginLeft: '20px', marginTop: '2%' }} />
                                  : null
                                }
                                <p style={{ fontSize: '15px', fontWeight: '500', color: '#E31A47', flex: 1 }}>
                                  {record && record.cross_consultation ? this.displayCrossCons(record.cross_consultation) : ""}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div style={{ borderLeft: '1px solid #707070', margin: '5px', marginBottom: '10px' }} />
                          <div style={{ display: 'flex', width: '34%' }}>
                            <div style={{ width: '40%', flex: 1, }}>
                              <div style={{ display: 'flex' }}>
                                {record &&
                                  record.surgeries &&
                                  record.surgeries.length > 0 ?
                                  <img src="/assets/images/icons/microscope.png" width={20} height={20} style={{ marginLeft: '20px', marginTop: '2px' }} />
                                  : null}
                                <p style={{ fontSize: '16px', fontWeight: '400', color: '#007CB0', flex: 1 }}>
                                  {record &&
                                    record.surgeries &&
                                    record.surgeries.length > 0
                                    ? this.surgeriesBgSucces(record, previousData)
                                    : " "}
                                </p>
                              </div>
                              <div style={{ display: 'flex' }}>
                                <p style={{ fontSize: '16px', fontWeight: '400', color: '#007CB0', flex: 1 }}>
                                  {record &&
                                    record.appointments &&
                                    record.appointments.length > 0
                                    ? this.appointmentsBgSucces(
                                      record,
                                      previousData
                                    )
                                    :
                                    " "}
                                </p>
                              </div>
                              <div style={{ display: 'flex' }}>
                                <p style={{ fontSize: '15px', fontWeight: '500', color: '#007CB0', marginLeft: '8%', flex: 1 }}>
                                  {record && record.TRANSFER_STATUS && record.bedTransferStatus.length
                                    ? this.showTransferNS(record)
                                    : " "
                                  }
                                </p>
                              </div>
                              <div style={{ display: 'flex' }}>
                                <p style={{ fontSize: '15px', fontWeight: '500', color: '#007CB0', marginLeft: '8%', flex: 1 }}>
                                {record.RemedinetInsuranceStatus && record.RemedinetInsuranceStatus.length>0 && record.RemedinetInsuranceStatus[0].payer_status ?record.RemedinetInsuranceStatus[0].payer_status:<span> </span>}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    ))}
                  </div>
                </div>
              )
            })
            }
          </Carousel>

        }



        <div className="current_page_nurse" style={{ backgroundColor: "white", height: '110px', marginTop: '2%', position: 'absolute', marginLeft: '48%', top: '610px' }}>
          {!this.state.loadding && <span style={{ color: '#c9c9c9' }}>
            Page: {this.state.currentPage}/{this.state.total_page}
          </span>}
        </div>

        <div className="current_page_nurse" style={{ backgroundColor: "white", height: '110px', marginTop: '30%' }}>

        </div>

        {footerArray.length > 0 &&
          <Marquee className="marquee-bg" play={footerArray.length > 0 && footerArray.length > 6 ? true : false} gradientColor={none}>
            <div className="row">
              {footerArray.length > 0 && footerArray.map((item, index) => {
                return (
                  <div className={"text-center mx-2"}>
                    <div className="footersize">
                      <i class="fas fa-procedures on-bed-icon"></i>
                      {item.bed_no ? item.bed_no : ''}
                      <span style={{ color: 'limegreen', paddingRight: index === (footerArray.length) - 1 ? "25px" : '' }}>
                        {item.bed_status
                          ? item.bed_status_cd === 'V'
                            ? ' Vacant'
                            : item.bed_status_cd === 'H'
                              ? ' House Keeping'
                              : item.bed_status_cd === 'R'
                                ? ' Retained'
                                : item.bed_status_cd === 'A'
                                  ? ' Attendant Using'
                                  : ' '
                          : ""}
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>
          </Marquee>
        }

      </div>
    );
  }
}

export default New_Nurse_display;